'use client'

import type { Button as ButtonFieldsFragment } from '@/graphql/types'
import {
  wrapExperience,
  type BaselineMapper,
  type ExperienceConfiguration,
  Reference,
} from '@ccpgames/eve-web-contentful'
import { parseExperiences } from '@/helpers/experiences'
import { createExperienceAwareEntry } from '@/components/templates/dynamic/experienceEntry'
import { Button } from './Button'

const mapButtonBaseline: BaselineMapper<ButtonFieldsFragment, ButtonFieldsFragment & { id: string }> = (entry) => {
  return { id: entry.sys.id, ...entry }
}

const parseButtonExperiences = (entry: ButtonFieldsFragment | undefined): ExperienceConfiguration<Reference>[] => {
  return parseExperiences<ButtonFieldsFragment>(entry)
}

const ButtonWithExperience = wrapExperience<ButtonFieldsFragment, ButtonFieldsFragment & { id: string }>(
  (baseline) => {
    return <Button cta={baseline} />
  },
  mapButtonBaseline,
  parseButtonExperiences,
)

export function ButtonExperience({ entry }: { entry: ButtonFieldsFragment }) {
  return <ButtonWithExperience entry={entry} />
}

const ButtonBaseComponent = ({ entry }: { entry: ButtonFieldsFragment }) => {
  return <Button cta={entry} />
}

export const ButtonEntry = createExperienceAwareEntry<ButtonFieldsFragment>(ButtonBaseComponent, ButtonExperience)
